module.exports = __webpack_public_path__ + "static/media/transactionDiscount.261f3094.svg";